import { useState } from "react";
import { api, notifyError } from "@/lib/api";
import { Calculator } from "@phosphor-icons/react";
import { Field, ResultPanel } from "./shared";

const TILES = [
  { key: "prsi_cap_applied", label: "Employer PRSI cap", money: true },
  { key: "relief_amount", label: "486C relief", money: true, color: "#00A86B" },
  { key: "net_ct_after_486c", label: "CT after relief", money: true },
];

export default function S486CCalc({ onSaved }) {
  const [f, setF] = useState({ corporation_tax_liability: "", employer_prsi: "", employee_count: 1, tax_year: new Date().getFullYear() });
  const [calc, setCalc] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const run = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/tax/calculate/s486c", {
        corporation_tax_liability: Number(f.corporation_tax_liability),
        employer_prsi: Number(f.employer_prsi),
        employee_count: Number(f.employee_count || 1),
        tax_year: Number(f.tax_year),
      });
      setCalc(r.data);
      onSaved && onSaved();
    } catch (err) { notifyError(err); }
    finally { setBusy(false); }
  };

  return (
    <div className="grid lg:grid-cols-2 gap-6">
      <form onSubmit={run} className="glass rounded-2xl p-6 space-y-4">
        <div>
          <div className="eyebrow mb-1">Section 486C — new-company CT relief</div>
          <p className="text-white/55 text-sm">Relief from Corporation Tax for a new company&apos;s first 5 years, capped by employer&apos;s PRSI.</p>
        </div>
        <Field label="Corporation-tax liability (€)" type="number" step="0.01" required data-testid="s486c-ct" value={f.corporation_tax_liability} onChange={(e) => set("corporation_tax_liability", e.target.value)} />
        <Field label="Qualifying employer PRSI paid (€)" type="number" step="0.01" required data-testid="s486c-prsi" value={f.employer_prsi} onChange={(e) => set("employer_prsi", e.target.value)} hint="Capped at €5,000 per employee, €40,000 total." />
        <div className="grid grid-cols-2 gap-4">
          <Field label="Employees" type="number" data-testid="s486c-employees" value={f.employee_count} onChange={(e) => set("employee_count", e.target.value)} />
          <Field label="Tax year" type="number" data-testid="s486c-year" value={f.tax_year} onChange={(e) => set("tax_year", e.target.value)} />
        </div>
        <button type="submit" disabled={busy} className="btn-gold w-full justify-center" data-testid="s486c-calculate"><Calculator size={16} weight="fill" /> {busy ? "Calculating…" : "Calculate 486C relief"}</button>
      </form>
      {calc ? <ResultPanel calc={calc} tiles={TILES} /> : (
        <div className="glass rounded-2xl p-6 flex items-center justify-center text-white/40 text-sm text-center">Enter your CT and employer PRSI to estimate 486C relief.</div>
      )}
    </div>
  );
}
